//Custo css import
import './style.css'

//React import
import { useEffect, useState } from 'react';

import { getSubaccounts, updateSubaccount, deleteSubaccount } from '../../../usecases/subaccounts-usecase';
import Table from '../../molecules/tablas/view';
import SearchInput from '../../atoms/SearchInput/view';
import { EmptyArray } from '../../../domain/empty/model';
import { Switch } from '@mui/material';

import { dispatchCustomEvent, listener } from '../../../utils/dispatch';
import ButtonAction from '../../atoms/buttonAction/view';
import { BiTrash, BiEdit } from 'react-icons/bi';
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
import ConfirmPopUp from '../../atoms/confirmPopUp/view';
import CustomBox from '../../atoms/container/container';

let debounceTimer;

function PlanCuentas({ profile, id = "none" }) {

    const [subaccounts, SetSubaccounts] = useState({
        total: 0,
        page: 1,
        page_size: 50,
        data: [],
    });

    const [editingId, setEditingId] = useState(null);
    const [tempDescription, setTempDescription] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        listener('update-subaccounts', () => update(1, 10));
        update();
    }, []);

    function update(
        page = subaccounts.page,
        page_size = subaccounts.page_size,
        filters = [{ label: "is_account", value: "true" }]
    ) {
        setLoading(true);
        SetSubaccounts(prev => ({ ...prev, data: [] }))
        getSubaccounts(page, page_size, filters).then(res => {
            var data = res.data
            if (data.total === 0) {
                SetSubaccounts(prev => ({ ...prev, data: EmptyArray }))
            } else {
                SetSubaccounts({ ...data, data: subaccountsMapper(data.data) })
            }
        }).catch((err) => {
            SetSubaccounts(prev => ({ ...prev, data: [] }))
        }).finally(() => {
            setLoading(false);
        })
    }

    function handleSearch(query) {
        clearTimeout(debounceTimer);
        if (query === '') {
            update();
        }
        debounceTimer = setTimeout(() => {
            update(
                subaccounts.page,
                subaccounts.page_size,
                [{ label: "is_account", value: "true" }, { label: 'query', value: query }]
            );
        }, 500);
    }

    function subaccountsMapper(data) {
        return data.map((item) => {
            const codeStr = item.code != null ? item.code.toString().padStart(2, '0') : '';
            const baseAccount = item.base_account?.account || '';
            const parentDescription = item.base_account?.description || '';
            const parentAccountFormatted = baseAccount ? `${baseAccount} - ${parentDescription}` : '';
            const accountNumber = `${baseAccount}${codeStr}`;
            return {
                "id": item.id,
                "full_account_name": parentAccountFormatted,
                "account": accountNumber,
                "description": item.description || '',
                "is_tax": !!item.is_tax,
                "need_third": !!item.need_third,
            };
        });
    }

    function handleStartEdit(itm) {
        setEditingId(itm.id);
        setTempDescription(itm.description);
    }

    function handleCancelEdit() {
        setEditingId(null);
        setTempDescription("");
    }

    function handleSaveEdit(itm) {
        if (itm.description === tempDescription) {
            handleCancelEdit();
            return;
        }
        handleTableFieldUpdate(itm, 'description', tempDescription);
        setEditingId(null);
    }

    function handleTableFieldUpdate(subaccount, field, newValue) {
        if (subaccount[field] === newValue) return;

        const updateData = {
            [field]: newValue
        };

        updateSubaccount(subaccount.id, updateData)
            .then(() => {
                dispatchCustomEvent("popup", {
                    message: `Subcuenta actualizada correctamente`,
                    type: "success"
                });
                // Actualizar el estado local
                SetSubaccounts(prev => ({
                    ...prev,
                    data: prev.data.map(item =>
                        item.id === subaccount.id
                            ? { ...item, [field]: newValue }
                            : item
                    )
                }));
            })
            .catch((error) => {
                dispatchCustomEvent("popup", {
                    message: `Error al actualizar subcuenta: ${error.message}`,
                    type: "error"
                });
            });
    }

    function handleDeleteSubaccount(subaccount) {
        dispatchCustomEvent('notification-confirm-delete-subaccount', { data: subaccount });
    }

    function confirmDelete(subaccount) {
        deleteSubaccount(subaccount.data.id)
            .then(() => {
                dispatchCustomEvent("popup", {
                    message: `Subcuenta ${subaccount.account} eliminada correctamente`,
                    type: "success"
                });
                update(subaccount.page, subaccount.page_size)
            })
            .catch((error) => {
                dispatchCustomEvent("popup", {
                    message: `Error al eliminar subcuenta: ${error.message}`,
                    type: "error"
                });
            });
    }



    return (
        <CustomBox style={{ maxHeight: "90%" }}>
            <div className='plan-cuentas-head-container'>
            </div>
            <Table
                paginatedData={subaccounts}
                maxHeight={"40vh"}
                getFunction={update}
                isLoading={loading}
                allowExport={true}
                exportFileName="plan-cuentas"
                allowPageSizeControl={true}
                allowSearch={true}
                onSearch={handleSearch}
                headersList={["Cuenta / Padre", "Auxiliar", "Descripcion", "Es Impuesto", "Necesita tercero"]}
                excludeList={["account_info", "id"]}
                formats={{
                    description: {
                        type: "custom",
                        children: (itm, index) => {
                            const isEditing = editingId === itm.id;
                            if (isEditing) {
                                return (
                                    <div className='inline-edit-container'>
                                        <input
                                            autoFocus
                                            className='inline-edit-input editing'
                                            value={tempDescription}
                                            onChange={(e) => setTempDescription(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') handleSaveEdit(itm);
                                                if (e.key === 'Escape') handleCancelEdit();
                                            }}
                                            onClick={(e) => e.stopPropagation()}
                                        />
                                        <div className='inline-edit-actions'>
                                            <button className='btn-save' title='Guardar' onClick={(e) => { e.stopPropagation(); handleSaveEdit(itm) }}>
                                                <AiOutlineCheck />
                                            </button>
                                            <button className='btn-cancel' title='Cancelar' onClick={(e) => { e.stopPropagation(); handleCancelEdit() }}>
                                                <AiOutlineClose />
                                            </button>
                                        </div>
                                    </div>
                                )
                            }
                            return (
                                <div className='inline-edit-preview'>
                                    <span>{itm.description}</span>
                                    <button className='btn-edit' title='Editar' onClick={(e) => { e.stopPropagation(); handleStartEdit(itm) }}>
                                        <BiEdit />
                                    </button>
                                </div>
                            )
                        }
                    },
                    is_tax: {
                        type: "custom",
                        children: (itm, index) => (
                            <Switch
                                checked={itm.is_tax}
                                onChange={(e) => handleTableFieldUpdate(itm, 'is_tax', e.target.checked)}
                            />
                        )
                    },
                    need_third: {
                        type: "custom",
                        children: (itm, index) => (
                            <Switch
                                checked={itm.need_third}
                                onChange={(e) => handleTableFieldUpdate(itm, 'need_third', e.target.checked)}
                            />
                        )
                    }
                }}
            >
                <ButtonAction onClick={handleDeleteSubaccount} title={<BiTrash />} />
            </Table>
            <ConfirmPopUp
                eventKey="delete-subaccount"
                msg="¿Estás seguro de eliminar esta subcuenta?"
                onAcept={confirmDelete}
            />
        </CustomBox>
    )
}

export default PlanCuentas
